<template>
  <b-modal v-if="visibleModalEditPhrase" id="modalEditPhrase"
           :visible="visibleModalEditPhrase"
           title="Phrase bearbeiten"
           size="lg"
           no-close-on-backdrop
           header-bg-variant="dark"
           header-border-variant="dark"
           header-text-variant="white"
           header-close-label="Abbrechen"
           hide-footer
           @hide="$store.commit('SET_ACTIVE_MODAL', null); $store.commit('SET_ACTIVE_MODAL_CONTENT', null)"
  >
    <component-form-phrase />
  </b-modal>
</template>

<script>

import componentFormPhrase from '@/components/forms/Phrase'

export default {
  name: 'Modals',
  components: {
    componentFormPhrase
  },
  computed: {
    visibleModalEditPhrase: function() {
      return this.$store.state.activeModal === 'modalEditPhrase'
    }
  },
  mounted () {
  }
}
</script>
